<template>
  <div class="NoticeForm">
    <el-container class="p-0">
      <el-main>
        <el-form 
          ref="form"
          label-width="70px" 
          class="form-label-70"
          :model="data" 
          :rules="rules" 
        >
          <el-row>
            <el-col :span="24">
              <el-form-item 
                prop="title"
                label="제목" 
              >
                <el-input 
                  v-model="data.title" 
                  maxlength="50" 
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item 
                prop="begin_date"
                label="시작일" 
              >
                <ADatePicker
                  v-model="data.begin_date"
                />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item 
                prop="end_date"
                label="종료일" 
              >
                <ADatePicker
                  v-model="data.end_date"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item 
                label="부서" 
              >
                <div class="inline">
                  <ACheckboxYN
                    v-model="data.branch_all_flag"
                  >전체</ACheckboxYN>
                </div>
                <div class="inline ml-default">
                  <el-select 
                    ref="branch_ids"
                    v-model="data.branch_ids" 
                    size="tiny" 
                    class="w-full"
                    :disabled="data.branch_all_flag === 'Y'"
                    multiple 
                    collapse-tags
                    @change="handleChangeBranches"
                  >
                    <el-option 
                      v-for="item in table_branch" 
                      :key="item.id" 
                      :label="item.name" 
                      :value="item.id"  
                    />
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item 
                label="그룹" 
              >
                <div class="inline">
                  <ACheckboxYN
                    v-model="data.user_group_all_flag"
                  >전체</ACheckboxYN>
                </div>
                <div class="inline ml-default">
                  <el-select 
                    ref="user_group_ids"
                    v-model="data.user_group_ids" 
                    size="tiny" 
                    class="w-full"
                    :disabled="data.user_group_all_flag === 'Y'"
                    multiple 
                    collapse-tags
                    @change="handleChangeBranches"
                  >
                    <el-option 
                      v-for="item in table_user_group" 
                      :key="item.id" 
                      :label="item.name" 
                      :value="item.id"  
                    />
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item 
                prop="content"
                label="내용">
                <el-input 
                  type="textarea" 
                  v-model="data.content" 
                  maxlength="500" 
                  rows="10"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="!is_new">
            <el-col :span="24">
              <el-form-item 
                label="재공지">
                  <ACheckboxYN v-model="refresh" />
                  <AHelper>이미 읽은 사용자도 공지 알람이 다시 표시됩니다.</AHelper>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-main>
      <el-footer>
        <el-button
          type="primary"
          v-shortkey="['f4']"
          :disabled="!has_grant_write"
          @shortkey.native="handleClickRegister"
          @click="handleClickRegister"
        >{{is_new ? $t('button.add') : $t('button.modify')}}(F4)</el-button>
        <el-button 
          type="danger" 
          v-if="!is_new" 
          :disabled="!has_grant_write"
          @click="handleClickDelete"
        >{{$t('button.delete')}}</el-button>
        <el-button 
          class="close-button" 
          @click="closeDialog"
        >{{$t('button.close')}}(Esc)</el-button>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";

export default {
  name: "NoticeForm",
  mixins: [form],
  data() {
    return {
      title: this.$t('title.notice'),
      rules: {
        title: [{ required: true, message: "제목을 입력해 주세요.", trigger: "blur" }],
        begin_date: [{ required: true, message: "시작일을 입력해 주세요.", trigger: "blur" }],
        end_date: [{ required: true, message: "종료일을 입력해 주세요.", trigger: "blur" }],
        content: [{ required: true, message: "내용을 입력해 주세요.", trigger: "blur" }]
      },
      refresh: 'N',
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          title: "",
          begin_date: this.util.getDate(0),
          end_date: this.util.getDate(7),
          content: "",
          branch_all_flag: 'N',
          branch_ids: null,
          user_group_all_flag: 'N',
          user_group_ids: null,
        };
      }
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_user_group", "table_branch"]),
    is_new: function() {
      return this.data.id < 1;
    }
  },
  methods: {
    /** Add or modify data */
    doRegister() {
      let api = this.is_new ? this.api.createNotice : this.api.updateNotice;
      let message = this.is_new ? this.$t('message.success_create') : this.$t('message.success_update');
      let data = Object.assign({}, this.data);
      if (this.refresh === 'Y') {
        data.refresh = 'Y'
      }
      api(data).then(res => {
        this.handleResult(res, message);
      })
    },
    /**Delete data */
    doDelete() {
      this.api.deleteNotice(this.data).then(res => {
        this.handleResult(res, this.$t('message.success_delete'));
      });
    },
    handleChangeBranches(values) {
      let reset = values.findIndex(v => v === null);
      if (reset < 0) { return; }
      this.data.branch_ids = null;
    },
    /**Click the Modify button */
    handleClickRegister() {
      if( !this.has_grant_write ) return;
      
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.doRegister();
      });
    },
    /**Click Delete button */
    handleClickDelete() {
      this.util.confirm_delete(this, this.title, this.doDelete );
    },
    handleResult(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, successMessage);
      this.$emit("completed", true);
    },
  }
};
</script>
